import { useState, useEffect } from 'react';
import { Plus, Send, Trash2, Edit2, Radio } from 'lucide-react';
import { adminAxios } from './AdminLayout';

export default function AdminBroadcasts() {
  var [broadcasts, setBroadcasts] = useState([]);
  var [loading, setLoading] = useState(true);
  var [showModal, setShowModal] = useState(false);

  function fetchBroadcasts() {
    adminAxios().get('/api/admin/broadcasts').then(function(r) { setBroadcasts(r.data); setLoading(false); });
  }
  useEffect(function() { fetchBroadcasts(); }, []);

  async function handleSend(id) {
    if (!window.confirm('Send this broadcast to all subscribed clients?')) return;
    try {
      var res = await adminAxios().post('/api/admin/broadcasts/send?broadcast_id=' + id);
      alert('Sent to ' + res.data.sent + ' clients (' + res.data.failed + ' failed)');
      fetchBroadcasts();
    } catch (err) { alert(typeof (err.response&&err.response.data&&err.response.data.detail)==='string'?err.response.data.detail:'Send failed'); }
  }

  return (
    <div data-testid="admin-broadcasts-page">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-outfit text-2xl font-bold text-slate-900">Broadcasts</h2>
        <button onClick={function(){setShowModal(true);}} className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-[#0096D6] text-white font-manrope text-sm font-semibold">
          <Plus className="w-4 h-4" /> New Broadcast
        </button>
      </div>

      {loading ? <div className="font-manrope text-slate-500">Loading...</div> :
       broadcasts.length === 0 ? <div className="text-center py-12 bg-white rounded-2xl border border-slate-100"><Radio className="w-10 h-10 text-slate-300 mx-auto mb-2" /><p className="font-manrope text-slate-500">No broadcasts yet</p></div> :
       <div className="space-y-3">
        {broadcasts.map(function(b) {
          return (
            <div key={b.id} className="bg-white rounded-2xl border border-slate-100 p-5 shadow-sm flex items-center justify-between">
              <div>
                <h4 className="font-manrope font-semibold text-slate-900">{b.subject}</h4>
                <div className="flex items-center gap-3 mt-1">
                  <span className={'text-xs font-semibold px-2 py-0.5 rounded-full ' + (b.status === 'sent' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700')}>{b.status}</span>
                  {b.sent_count > 0 && <span className="font-manrope text-xs text-slate-400">Sent to {b.sent_count}</span>}
                </div>
              </div>
              <div className="flex items-center gap-2">
                {b.status === 'draft' && <button onClick={function(){handleSend(b.id);}} className="p-2 hover:bg-blue-50 rounded-lg" title="Send"><Send className="w-4 h-4 text-[#0096D6]" /></button>}
              </div>
            </div>
          );
        })}
       </div>
      }

      {showModal && <BroadcastModal onClose={function(){setShowModal(false);}} onSaved={function(){setShowModal(false);fetchBroadcasts();}} />}
    </div>
  );
}

function BroadcastModal({ onClose, onSaved }) {
  var [form, setForm] = useState({ subject: '', content_html: '', target: 'all_subscribed', reply_mode: 'david_only' });
  var [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await adminAxios().post('/api/admin/broadcasts', form);
      onSaved();
    } catch (err) { alert(typeof (err.response&&err.response.data&&err.response.data.detail)==='string'?err.response.data.detail:'Failed'); }
    finally { setSaving(false); }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-white rounded-2xl w-full max-w-lg p-6 m-4 shadow-2xl" onClick={function(e){e.stopPropagation();}}>
        <h3 className="font-outfit text-xl font-bold text-slate-900 mb-4">New Broadcast</h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="font-manrope text-xs font-medium text-slate-600 block mb-1">Subject *</label>
            <input value={form.subject} onChange={function(e){setForm(Object.assign({},form,{subject:e.target.value}));}} className="w-full px-3 py-2 rounded-lg border border-slate-200 font-manrope text-sm" required />
          </div>
          <div>
            <label className="font-manrope text-xs font-medium text-slate-600 block mb-1">Content (HTML) *</label>
            <textarea value={form.content_html} onChange={function(e){setForm(Object.assign({},form,{content_html:e.target.value}));}} className="w-full px-3 py-2 rounded-lg border border-slate-200 font-manrope text-sm h-32 resize-none" required placeholder="<h2>Announcement</h2><p>Your message here...</p>" />
          </div>
          <div>
            <label className="font-manrope text-xs font-medium text-slate-600 block mb-1">Recipients</label>
            <select value={form.target} onChange={function(e){setForm(Object.assign({},form,{target:e.target.value}));}} className="w-full px-3 py-2 rounded-lg border border-slate-200 font-manrope text-sm">
              <option value="all_subscribed">All subscribed clients</option>
              <option value="specific_clients">Specific clients (select after saving)</option>
            </select>
          </div>
          <div>
            <label className="font-manrope text-xs font-medium text-slate-600 block mb-1">Reply Handling</label>
            <select value={form.reply_mode} onChange={function(e){setForm(Object.assign({},form,{reply_mode:e.target.value}));}} className="w-full px-3 py-2 rounded-lg border border-slate-200 font-manrope text-sm">
              <option value="david_only">Reply to David only</option>
              <option value="offers_only">Reply to Offers only</option>
              <option value="both">Reply to both</option>
            </select>
          </div>
          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded-xl border border-slate-200 font-manrope text-sm">Cancel</button>
            <button type="submit" disabled={saving} className="px-4 py-2 rounded-xl bg-[#0096D6] text-white font-manrope text-sm font-semibold disabled:opacity-50">{saving ? 'Saving...' : 'Save as Draft'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
